// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-404-js": () => import("./../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("./../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-work-in-progress-js": () => import("./../src/pages/work-in-progress.js" /* webpackChunkName: "component---src-pages-work-in-progress-js" */),
  "component---src-templates-chapter-template-js": () => import("./../src/templates/chapter-template.js" /* webpackChunkName: "component---src-templates-chapter-template-js" */)
}

